// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a9fd461b","644":"7051398a","667":"8f492ef3"}[chunkId] + ".chunk.js";
};